import { Tooltip } from "@material-ui/core";
import { IconButton } from '@mui/material';
import { ReactComponent as ExportIcon } from 'assets/icons/Export.svg';
import { ReactComponent as ShareIcon } from 'assets/icons/Frame 239526.svg';
import { ReactComponent as BlankLink } from 'assets/icons/Group 240018.svg';
import { ReactComponent as InfoIcon } from 'assets/icons/Layer_2.svg';
import { ReactComponent as Share } from 'assets/icons/ShareClass.svg';
import CopySvgComponent from "assets/icons/svg/copy";
import Action from 'components/ActionPopOver';
import { AlertMessage } from "components/AlertMessage";
import { formatDate, numberFormat } from "helper";
import moment from "moment";
import React, { useEffect } from 'react';
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useHistory } from 'react-router-dom';
import './ClassDrawer.scss';
import { fontConfig } from "theme/fontConfig";
const ClassDrawer = ({
  drawerData,
  setIsDrawerOpen,
  setConfirmDialog,
  setDeleteClassId,
  setArchiveClassId,
  toggle,
  setExportAllTable,
  exportAllTable
}) => {
  const history = useHistory();
  const organization = localStorage.getItem('organization')
    ? JSON.parse(localStorage.getItem('organization'))
    : null;
  const orgKey = organization?.orgkey;
  const mainUrl = window.location.origin;
  const checkDomain =
    mainUrl === 'https://admin.eztmpl.dev' ||
    mainUrl === 'http://localhost:3000'
      ? `https://shalom.eztmpl.dev/school/${drawerData?._id}`
      : mainUrl === 'https://admin.eztmpl.com'
      ? `https://demo.eztmpl.com/school/${drawerData?._id}`
      : mainUrl === 'https://admin.easyshul.com'
      ? `https://${orgKey}.easyshul.com/school/${drawerData?._id}`
      : null;

    const [copyLinkSuccess, setCopyLinkSuccess] = React.useState(false);

    useEffect(() => {
      const timer = setTimeout(() => {
        setCopyLinkSuccess(false);
      }, 2000);
      return () => clearTimeout(timer);
    }, [copyLinkSuccess]);

  const previewClass = () => {
    window.open(checkDomain, '_blank');
  };
  const calculateDiscount = () => {
      const discountTotal = drawerData?.class_pricing?.total_to_pay;
      let discountAmount = 0;
      const discount = drawerData.class_discount?.map((item) => {
          if (item?.discount_type === 'date') {
              const endDate = moment(item?.end_date).format("MM/DD/YYYY")
              const startDate = moment(item?.start_date).format("MM/DD/YYYY")
              const currentDate = moment(new Date()).format("MM/DD/YYYY")
              if (startDate <= currentDate && endDate >= currentDate) {
                  if (item?.price_type === "fixed") {
                      discountAmount += item?.value
                  } else {
                    discountAmount = (discountTotal * item?.value) / 100 + discountAmount
                  }
              } else {
                  console.log("The discount date is expired ");
              }
          } else if (item?.discount_type === 'amount') {
            if(discountTotal >= item?.amount){
              if (item?.price_type === "fixed") {
                  discountAmount += item?.value
              } else {
                discountAmount = (discountTotal * item?.value) / 100 + discountAmount
              }
            }
          } else if (item?.discount_type === 'quantity') {
              if (item?.quantity && item?.quantity > 4) {
                  if (item?.price_type === "fixed") {
                      discountAmount += item?.value
                  } else {
                      discountAmount = (discountTotal * item?.value) / 100 + discountAmount;
                  }
              }
          }
      })
      const totalAfterDiscount = discountTotal ? (+discountTotal - +discountAmount) : 0
      return totalAfterDiscount

  }

  return (
    <div className="class__drawer">
        {copyLinkSuccess && (
          <div className="copy-alert">
            <AlertMessage type="success" content="URL Copied Successfully" />
          </div>
        )}
      <div
        className="d-flex justify-content-between align-items-center mb-5"
        style={{ fontSize: '16px', cursor: 'pointer', fontWeight: 'bold' }}
        onClick={() => {
          setIsDrawerOpen(false);
        }}
      >
        X
       <div
        className="d-flex align-items-center"
        style={{
          gap: '10px',
        }}
       >
        <div className="preview_button" onClick={previewClass} role="button">
              Registration link <BlankLink className="ml-2" />
          </div>
          <Tooltip title="Copy Link">
            <CopyToClipboard text={checkDomain}>
              <CopySvgComponent onClick={(e) => {
                e.stopPropagation();
                setCopyLinkSuccess(true);
              }} />
            </CopyToClipboard>
          </Tooltip>
        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center mt-3">
        <p className="drawer_class_name">{drawerData?.class_name}</p>
        <div className="popover__drawer">
          <IconButton className="p-0 px-2">
            <Action
              onEditClick={() => history.push(`/edit-class/${drawerData?._id}`)}
              onArchiveClick={
                toggle
                  ? () => {
                      setArchiveClassId([drawerData?._id]);
                      setConfirmDialog(true);
                    }
                  : undefined
              }
              onClassDeleteClick={() => {
                setDeleteClassId(drawerData?._id);
                setConfirmDialog(true);
              }}
              style={{
                minHeight: "50px",
              }}
              action={'classDrawer'}
            />
          </IconButton>
        </div>
      </div>
      <div className="internal_drawer">
        <div className="drawer_classInfo">
          <div className="class_info_title mb-3">
            <h3 className="text-center">Registration Starts</h3>
            <h3 className="text-center">Registration Ends</h3>
            <h3 className="text-center">Form</h3>
          </div>
          <div className="class_info_value">
            <p className="text-center">
              {formatDate({date:drawerData?.class_start_date, formatType:"defaultWithUTC"})}
            </p>
            <p className="text-center text-nowrap">
              {drawerData?.always_available
                ? 'Always Available'
                : formatDate({date:drawerData?.class_end_date, formatType:"defaultWithUTC"} )}
            </p>

            <p className="d-flex align-items-center justify-content-center">
              Created
              <BlankLink className="ml-3" />
            </p>
          </div>
        </div>
        <div className="class_details_section mt-4">
          <div>
            <h2
              title={drawerData?.class_details?.infiniteParticipants ? "∞" : numberFormat({number:drawerData?.class_details?.maximum_participants, decimal: 0})}
            >
              {drawerData?.class_details?.infiniteParticipants ? <span style={{
                fontSize: '30px',
                fontFamily: fontConfig.SchoolClassDrawerTextFont.family
              }}>&#8734;</span> : numberFormat({number:drawerData?.class_details?.maximum_participants, decimal: 0})}
            </h2>
            <h4>Max participants</h4>
          </div>
          <div>
            <h2>
              {drawerData?.class_details?.ageStart}-
              {drawerData?.class_details?.ageEnd}{' '}
            </h2>
            <h4>Age Range</h4>
          </div>
        </div>
        <div className="class-drawer__actions">
            <button className="class-drawer__actions-btn" onClick={()=>setExportAllTable(!exportAllTable)}><ExportIcon/><span>Export Class Data</span></button>
            <button
              className="class-drawer__actions-btn"
              onClick={() => {
                previewClass();
              }}
            ><Share/><span>Share Registration Link</span></button>
        </div>
        {/* <div className="Share_Registration_link">
          <ShareIcon className="mr-3" />
          Share Registration link
        </div> */}
        {drawerData?.description?.replace(/&lt;/g, '<') !== '<p></p>\n' && (
          <div className="drawer_description">
            <h3>Description</h3>
            <p
              dangerouslySetInnerHTML={{
                __html: drawerData?.description?.replace(/&lt;/g, '<'),
              }}
            ></p>
          </div>
        )}
        <div className="non_member_allowing mt-4">
          <InfoIcon className="mr-3" />
          <p>
            Non-Members are {!drawerData?.allow_non_members_register && 'not'}{' '}
            allowed to register to this class
          </p>
        </div>
        <div className="price_section mt-10">
          {drawerData?.class_pricing?.prices?.length > 0 &&
            drawerData?.class_pricing?.prices?.map((price) => (
              <div className="subtotal mb-4">
                <p>{price?.title}</p>
                <h4>
                  {numberFormat({number:+price?.amount, decimal: 2,style:"currency"})}
                </h4>
              </div>
            ))}

          {drawerData?.class_discount?.length > 0 &&
            drawerData?.class_discount?.map((dis) => (
              <div className="discount mb-4">
                <p>
                  {dis?.discount_type === 'date' &&
                  (dis?.start_date || dis?.end_date)
                    ? `${dis?.discount_name} | ${formatDate({date:dis?.start_date, formatType:"defaultWithUTC"})}-${formatDate({date:dis?.end_date, formatType:"defaultWithUTC"})}`
                    : dis?.discount_name}
                </p>
                <h4>
                  - {dis?.price_type?.toLowerCase() === 'percentage' ? `${dis?.value}%` : numberFormat({number:+dis?.value, decimal: 2,style:"currency"})}
                </h4>
              </div>
            ))}
          <hr className="mb-5" />
          <div className="total">
            <p>TOTAL</p>
            <h4>
              {numberFormat({number:drawerData?.class_pricing?.total_cost ? calculateDiscount() : 0, decimal: 2,style:"currency"})}
            </h4>
          </div>
        </div>
      </div>
   
    </div>
  );
};

export default ClassDrawer;
